// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3Vy0q","box":"WorkspacesBox_box__1Z2rC","node":"WorkspacesBox_node__2CCOU"};